export const notificationTypes = {
    SUCCESS: 1,
    INFO: 2,
    WARNING: 3,
    ERROR: 4,
    DEFAULT: 1
}